import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';

export default class CardList {
    constructor() {
        this.sections = document.querySelectorAll('.block-card-list');
        this.ready();
    }

    ready() {
        if (this.sections.length > 0) {
            this.sections.forEach((section) => {
                const slider = section.querySelector('.swiper');
                const navigationNext = section.querySelector('.slider-button-next');
                const navigationPrev = section.querySelector('.slider-button-prev');
                const pagination = section.querySelector('.swiper-pagination');

                // Adiciona transição suave nos slides
                // slider.querySelectorAll('.swiper-slide').forEach(slide => {
                //     slide.style.transition = 'transform 0.3s ease';
                // });

                const swiperInstance = new Swiper(slider, {
                    modules: [Pagination, Navigation],
                    grabCursor: false,
                    allowTouchMove: true,
                    centeredSlides: true,
                    spaceBetween: 0,
                    pagination: {
                        el: pagination,
                        clickable: true,
                        type: 'bullets'
                    },
                    navigation: {
                        nextEl: navigationNext,
                        prevEl: navigationPrev,
                    },
                    breakpoints: {
                        0: {
                            initialSlide: 0,
                            slidesPerView: 1.3,
                        },
                        1024: {
                            initialSlide: 1,
                            slidesPerView: 3,
                            slidesOffsetAfter: 0,
                            slidesOffsetBefore: 0,
                        },
                    },
                    on: {
                        init: (swiper) => {
                            this.updateScale(swiper);
                            swiper.slides.forEach(slide => slide.classList.remove('active-center'));
                            swiper.slides[swiper.activeIndex].classList.add('active-center');
                        },
                        slideChange: (swiper) => {
                            this.updateScale(swiper);
                            swiper.slides.forEach(slide => slide.classList.remove('active-center'));
                            swiper.slides[swiper.activeIndex].classList.add('active-center');
                        },
                        progress: (swiper) => {
                            // this.updateScale(swiper);
                        }
                    }
                });
            });
        }
    }

    // Método para atualizar a escala dos slides
    updateScale(swiper) {
        swiper.slides.forEach(slide => {
            const slideProgress = slide.progress;
            const scale = 1 - Math.min(Math.abs(slideProgress * 0.3), 0.3); // central = 1, laterais = 0.7
            slide.style.transform = `scale(${scale})`;
        });
    }
}

if (document.querySelector('.block-card-list')) {
    new CardList();
}
